module.exports = __webpack_public_path__ + "fonts/Canada-Bold.efeb90e97a4aa0d23be2793244d1acb6.woff";